import * as React from "react";
import SessionPanel from "../../components/shared/SessionPanel";
import { emrErrorSvg } from "utils/StaticPaths";
import { CgRepeat } from "react-icons/cg";

const UncaughtErrorsContainer: React.FC = () => {
  return (
    <SessionPanel
      title={"Uh Oh! Unexpected error occured"}
      subtitle={`Our engineers have been notified and will be investigating it.
        In the meanwhile, you might want to try again by refreshing the page.`}
      image={emrErrorSvg}
      primaryButton={{
        text: `Refresh`,
        action: () => {
          window.location.reload();
        },
        icon: <CgRepeat />,
      }}
      isDisplayCentered
    />
  );
};

export default UncaughtErrorsContainer;
